export default __webpack_public_path__ + "static/media/group_2.c8c0d9bf.png";